import type { AssetMessage } from "@/api/connectAssets";
import type {
  CatalogAssetListItem,
  MediaLibraryAssetItem,
} from "@/types/catalogAssets";

export function catalogAssetToAssetMessage(
  asset: CatalogAssetListItem | MediaLibraryAssetItem,
): AssetMessage {
  const mediaType = asset.mime_type ?? `${asset.type}/`;
  const displayName = asset.file_name || asset.title || asset.handle;

  return {
    // Prefer the numeric id (needed by the delete endpoints) when the list
    // exposes it; otherwise callers fall back to `asset_key` (the handle).
    id: asset.id != null ? String(asset.id) : undefined,
    asset_key: asset.handle,
    rj_site_id: "",
    original_filename: displayName,
    label: displayName,
    media_type: mediaType,
    size_bytes: asset.file_size,
    cdn_url: asset.url,
    gcs_url: asset.url,
    upload_status: asset.upload_status,
    create_date: "",
    modify_date: "",
  };
}
